import { getDay, isToday, differenceInCalendarDays } from 'date-fns'

const dayWeek = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado']

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const uid = () =>
  Math.round(Date.now() / 1000) + Math.floor(Math.random() * 69)

export function uuid () {
  let dt = new Date().getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (dt + Math.random() * 16) % 16 | 0
    dt = Math.floor(dt / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
}

export   function randomName(size : number) : string {
    let result = '';
    const character = 'abcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < size; i++) {
        result += character.charAt(Math.floor(Math.random() * character.length));
    }
    return result;
}

export const isKeyExists = (obj: object, key: string) => {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

export const notificationMp3 :string = `${process.env.BASE_URL}assets/music/notification-chat-internal-received-message.mp3`
export const notificationOgg :string = `${process.env.BASE_URL}assets/music/notification-chat-internal-received-message.aac`

export function musicReceiveMessage() {
  try {
    const audioMp3 = new Audio(notificationMp3)
    audioMp3.play()
  } catch (error) {
    const audioOgg = new Audio(notificationOgg)
    audioOgg.play()
  }
}

export const imageUserDefault = (): string => `${process.env.BASE_URL}assets/image/no_user.png`
export const imageDefault = (): string => `${process.env.BASE_URL}assets/image/no_photo.png`

export function fixedUserPhoto(e: { target: HTMLInputElement }) {
  e.target.src = `${process.env.BASE_URL}assets/image/no_user.png`
}
export const isIconTypeFile = { image: 'Camera', audio: 'Music', video: 'Video', text: '', document: 'File', file: 'File', none: 'Folder' } as const

export function isTypeFile(type: string): 'image' | 'video' | 'audio' | 'file' {
  if (type.includes('image')) {
    return 'image'
  }
  if (type.includes('video')) {
    return 'video'
  }
  if (type.includes('audio')) {
    return 'audio'
  }
  return 'file'
}

export function formateImage(img: string) {
  if (img) {
    if (img.indexOf('http') >= 0) {
      return img
    } else {
        const dominioAtual = window.location.origin;
      return dominioAtual + '/storage/' + img
    }
  }
  return imageUserDefault
}

export function convertDateSidebar(date: string): string {
  const d = new Date(date)
  if (isToday(d)) {
    return `${formatDayMonthForDate(d.getHours())}:${formatDayMonthForDate(d.getMinutes())}`
  }
  if (d.getFullYear() === new Date().getFullYear()) {
    return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}`
  }
  return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}/${d.getFullYear()}`
}

function formatDayMonthForDate(item: number): string {
  if (item < 10) {
    return `0${item}`
  }
  return item.toString()
}

export function timer(ms: number): Promise<void> {
  return new Promise(function (resolve) { setTimeout(resolve, ms) })
}

export function getTextDate(date: number|string|Date): string {
  const d = new Date(date)
  const today = new Date()
  const diff = differenceInCalendarDays(today, d)
  if (diff === 0) {
    return 'Hoje'
  } else if (diff === 1) {
    return 'Ontem'
  } else if (diff < 7) {
    return dayWeek[getDay(d)]
  } else if (d.getFullYear() === today.getFullYear()) {
    return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}`
  }
  return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}/${d.getFullYear()}`
}

export function convertDate(date: number|string|Date): string {
  const d = new Date(date)
  const today = new Date()
  const result = differenceInCalendarDays(today, d)
  if (result === 0) {
    return `Hoje às ${formatDayMonthForDate(d.getHours())}:${formatDayMonthForDate(d.getMinutes())}`
  } else if (result === 1) {
    return `Ontem às ${formatDayMonthForDate(d.getHours())}:${formatDayMonthForDate(d.getMinutes())}`
  } else if (result < 7) {
    const day = dayWeek[getDay(d)]
    return `${day} às ${d.getHours()}:${d.getMinutes()}`
  } else if (d.getFullYear() === today.getFullYear()) {
    return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}`
  }
  return `${formatDayMonthForDate(d.getDate())}/${formatDayMonthForDate(d.getMonth() + 1)}/${d.getFullYear()}`
}

export function getTime(date: number|string|Date): string {
  const d = new Date(date)
  return `${formatDayMonthForDate(d.getHours())}:${formatDayMonthForDate(d.getMinutes())}`
}

export function assignEntries(
  defaultValues: Record<string, unknown>,
  payload: Record<string, unknown>
): Record<string, unknown> {
  return Object.keys(defaultValues).reduce(
    (acc, key) => ({ ...acc, [key]: payload[key] ?? defaultValues[key] }),
    {}
  )
}

export function isLocalhost () : boolean {
  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    return true
  }
  return false
}
